import { unique } from 'lib/array/arrayUtils'

/**
 * `list.offerIds` must be the Redux-received ids for this list key, before
 * client exclusions or unpriced filtering. `getMinOffers` uses that same count.
 */
function isOfferListStreamIncomplete(
  list: Pick<App.OfferList, 'offerIds' | 'fetching' | 'error' | 'streamEnded' | 'offerCount' | 'socketListenersStatus'>,
  minRequiredOffers?: number,
): boolean {
  if (!minRequiredOffers) {
    return false
  }

  if (list.error) {
    return false
  }

  const receivedCount = unique(list.offerIds).length
  if (receivedCount >= minRequiredOffers) {
    return false
  }

  if (list.streamEnded) {
    return false
  }

  if (typeof list.offerCount === 'number' && list.offerCount <= receivedCount) {
    return false
  }

  return list.fetching || list.socketListenersStatus === 'listening'
}

export default isOfferListStreamIncomplete
